import styles from './styles.module.scss'
import clsx from 'clsx'
import { formatChangeValue } from 'src/utils/number/number'
import { formatCurrency2String } from 'src/utils/number/currency'
import useWidth from 'src/hooks/useWidth'
import Colors from 'src/components/TreeMap/components/Colors'
import { ExchangeHeaderFees } from '../index'
import { intl } from 'src/i18n'

export const MarketInfoBlock = ({ data }) => {
  const {
    reportedVolumeChange,
    reportedVolume,
    adjustedVolume,
    reportedVolume30d,
    reportedVolumeBTC30d,
    reportedVolumeBTC,
    adjustedVolumeBTC,
  } = data
  const { isMobile } = useWidth()

  const renderChange = change => {
    const colors = new Colors().createScale()
    const percentPriceChange = change ? formatChangeValue(change, false) : null
    return (
      <div
        className={styles.priceChange}
        style={{
          color: colors(Math.round(change * 100) / 100),
        }}
      >
        ({percentPriceChange ? `${percentPriceChange}%` : '?'})
      </div>
    )
  }

  return (
    <div className={styles.infoBlock}>
      <div className={styles.infoBlockTop}>
        <div className={clsx(styles.infoColumn, styles.top)}>
          <div>
            {intl.t('exchangeDetails.components.marketInfoBlock.report24h')}
          </div>
          <div className={styles.infoWithChange}>
            <div className={styles.infoBlockValue}>
              $
              {`${formatCurrency2String(
                reportedVolume < 0 ? adjustedVolume : reportedVolume,
                false,
                '0,0'
              )} `}
            </div>
            {reportedVolume >= 0 && renderChange(reportedVolumeChange)}
          </div>
          <div>{`${formatCurrency2String(
            reportedVolumeBTC < 0 ? adjustedVolumeBTC : reportedVolumeBTC,
            false,
            '0,0'
          )} BTC`}</div>
        </div>
        {reportedVolume30d > 0 && (
          <div className={clsx(styles.infoColumn, styles.top)}>
            <div>
              {intl.t('exchangeDetails.components.marketInfoBlock.report30d')}
            </div>
            <div className={styles.infoBlockValue}>
              ${formatCurrency2String(reportedVolume30d, false, '0,0')}
            </div>
            <div>{`${formatCurrency2String(
              reportedVolumeBTC30d,
              false,
              '0,0'
            )} BTC`}</div>
          </div>
        )}
      </div>
      {!isMobile && <ExchangeHeaderFees data={data} />}
    </div>
  )
}

export default MarketInfoBlock
